<div class="flex justify-content-between align-content-center bb">

 <span class="back-btn mx-4 my-2"  (click)="setTheme('back')">
  <img class="px-2" width="30px" src="assets/images/back_arrow.svg" alt=""> Back
 </span>
  <span class="top-text text-xl font-semibold">
          You are previewing Template
  </span>
    <span class="usetheme-btn mx-4 my-2"  (click)="setTheme('usetheme',_businessSetup?.selectedTheme)">
        Use Template
     </span>
</div>
<div class="flex  justify-content-center">
    <div class="col flex justify-content-center box mx-5" >

      <div class="image-container">
        <img [src]="_businessSetup?.selectedTheme?.imageUrl" alt="Image 1">
    </div>
    </div>
</div>
<p-dialog [showHeader]="false" [(visible)]="displayConfirmContinueDialog" [style]="{width: '40vw'}" modal="true"
    [baseZIndex]="10000" class="p3" >

    <div class="modal p-4">
      <div class="modal-header justify-content-center">
        <h3>Your Template Is Ready to Customize!</h3>
        <!-- <i class="pi pi-times p-2 cursor-pointer" (click)="closeModal()"></i> -->
      </div>
      <div class="modal-body">
        <!-- <i class="pi pi-info-circle text-4xl px-3"></i> -->
        <p>
          Your online store is all set up with the new template! You can start editing it right away to match your brand or preview how it looks to customers.
        </p>
      </div>
      <div class="modal-footer">
        <span class="cancel-btn mx-2" (click)="confirmWebsite()"> View your store <i class="pi pi-arrow-up-right px-1"></i></span>
        <span class="confirm-btn" (click)="confirmEditor()"> Customize your store <i class="pi pi-arrow-up-right px-1"></i></span>
      </div>
    </div>
</p-dialog>


<p-dialog [showHeader]="false" [(visible)]="showConfirmation" [style]="{width: '40vw'}" modal="true"
    [baseZIndex]="10000" class="p3" >

    <div class="modal p-4">
      <div class="modal-header justify-content-between">
        <div class="center-content">
          <h3>Confirm Template Selection</h3>
        </div>
  
        <div class="right-content">
          <i class="pi pi-times p-2 cursor-pointer" (click)="closeModal()"></i>
        </div>
      </div>
      <div class="modal-body">
        <p>Template selection is a one-time action and can’t be 
          changed later; however, you can customize the template to fit your
        needs.
        </p>
      </div>
      <div class="modal-footer">
        <span class="cancel-btn" (click)="closeModal()"> <i class="pi pi-times px-1"></i> Cancel</span>
        <span class="confirm-btn" (click)="confirmTheme()"> <i class="pi pi-check px-1"></i> Confirm Template</span>
      </div>
    </div>
</p-dialog>